import {Component, Input} from '@angular/core';
import {UiConfigService} from '@lv1871/core';
import {MatTableDataSource} from '@angular/material/table';
import {Fonds} from '../../../models/fonds';
import {FondsMitAnteil} from '../../../models/fondsMitAnteil';

@Component({
    selector: 'lv-anlauf-ablauf-management-table',
    templateUrl: './anlauf-ablauf-management-table.component.html',
    styleUrls: ['./anlauf-ablauf-management-table.component.scss'],
    standalone: false
})
export class AnlaufAblaufManagementTableComponent {
  @Input()
  public dataSource: MatTableDataSource<FondsMitAnteil>;
  @Input()
  public isLastRowBold: boolean;

  public displayedColumns: string[] = ['anteil', 'name', 'risikoklasse', 'factsheet', 'esgreport'];

  constructor(private _uiConfigService: UiConfigService) { }
}
